import React from 'react'
import { useTranslation } from '../i18n'

import Button from './Button'

interface Props {
  onClose?: () => void
}
export default function IENotification({ onClose }: Props) {
  const { t } = useTranslation()

  return (
    <div className="IENotification">
      <div className="IENotification__wrapper">
        <h2 className="IENotification__title">{t('browserSupport.title')}</h2>
        <p className="IENotification__body">{t('browserSupport.body')}</p>
        <div className="IENotification__browsers">
          <a className="IENotification__browser" href={`${t('browserSupport.chrome')}`} target="_blank" rel="noopener">
            <img
              className="IENotification__browserImage"
              src="/nextjs/static/browser/img-chrome.png"
              alt="Google Chrome icon"
            />
            <div className="IENotification__browserName">Google Chrome</div>
          </a>
          <a className="IENotification__browser" href={`${t('browserSupport.edge')}`} target="_blank" rel="noopener">
            <img
              className="IENotification__browserImage"
              src="/nextjs/static/browser/img-edge.png"
              alt="Microsoft Edge icon"
            />
            <div className="IENotification__browserName">Microsoft Edge</div>
          </a>
          <a className="IENotification__browser" href={`${t('browserSupport.safari')}`} target="_blank" rel="noopener">
            <img
              className="IENotification__browserImage"
              src="/nextjs/static/browser/img-safari.png"
              alt="Safari icon"
            />
            <div className="IENotification__browserName">Safari</div>
          </a>
        </div>
        <Button
          className="IENotification__button"
          theme="iconOnly"
          size="small"
          title="close"
          onClick={onClose}
          iconType="FunClose"
        />
      </div>
    </div>
  )
}
